<template>
  <div class="vkb_nak vkb_nak_vrnet vkb_nak_generationendepot">
    <div ref="vrnet_iframe" class="large-12 columns">
      <div class="row">
        <div class="small-12 medium-12 large-12 vrnet-org-box">
          <h2>Pers&ouml;nliche Angaben</h2>
          <div class="vrnet-hint">
            <div :class="['error-box', { 'open': invalidId > 0 }]">
              <vrnet-icons class-name="vrnet-icon icon-error notice" type="note"/>
              <h3>Bitte &uuml;berpr&uuml;fen Sie die markierten Eingabefelder.</h3>
            </div>
          </div>
          <div class="vrnet-row-input">
            <label :class="[hintInfoId == 1 ? 'orange' : 'normal', {'error': invalidId == 1}]">
              <span class="input-active" @click="setFocusToInput('input_age')">Alter</span>
              <span class="vrnet-icon-wrapper" @click="onHintIconClick(1)">
                <vrnet-icons :class-name="['vrnet-icon icon-hint', { 'open' : hintInfoId == 1 }]" :type="hintInfoId == 1 ? 'info-orange' : 'info-blue'"/>
              </span>
              <span v-if="invalidId == 1" class="vrnet-icon-wrapper" @click="onErrorIconClick(invalidId)">
                <vrnet-icons :class-name="['vrnet-icon icon-error', { 'open' : hintErrorId == 1 }]" type="error"/>
              </span>
            </label>
            <div class="vrnet-hint show-mobile">
              <div v-if="hintInfoId == 1" class="hint-wrapper tooltip">
                <div class="hint-info">
                  {{ tooltip.age }}
                </div>
              </div>
              <div v-if="invalidId == 1 && hintErrorId == 1" class="hint-wrapper error">
                <div class="hint-error">
                  <p>Bitte geben Sie ein Alter zwischen {{ minAge }} und {{ maxAge }} Jahren an.</p>
                </div>
              </div>
            </div>
            <label class="label-right">
              <div class="input-wrapper">
                <input ref="input_age" :value="form.age" :class="['input-text', { 'error': invalidId == 1 }]" type="text" @input="(e) => setAge(e.target.value)">
              </div>
              <span class="text">Jahre</span>
            </label>
            <div class="vrnet-hint">
              <div v-if="hintInfoId == 1" class="hint-wrapper tooltip hide-mobile">
                <div class="hint-info">
                  {{ tooltip.age }}
                </div>
              </div>
              <div v-if="invalidId == 1 && hintErrorId == 1" class="hint-wrapper error hide-mobile">
                <div class="hint-error">
                  <p>Bitte geben Sie ein Alter zwischen {{ minAge }} und {{ maxAge }} Jahren an.</p>
                </div>
              </div>
            </div>
          </div>

          <div class="vrnet-row-input">
            <label :class="[hintInfoId == 3 ? 'orange' : 'normal', {'error': invalidId == 2}]">
              Berechnungsalter f&uuml;r die Kapitalleistung
              <span class="vrnet-icon-wrapper" @click="onHintIconClick(3)">
                <vrnet-icons :class-name="['vrnet-icon icon-hint', { 'open' : hintInfoId == 3 }]" :type="hintInfoId == 3 ? 'info-orange' : 'info-blue'"/>
              </span>
            </label>
            <div class="vrnet-hint show-mobile">
              <div v-if="hintInfoId == 3" class="hint-wrapper tooltip">
                <div class="hint-info">
                  {{ tooltip.destination_age }}
                </div>
              </div>
            </div>
            <label class="label-right">
              <div class="input-wrapper">
                <select :value="form.destination_age" class="input-select no-border" dir="rtl" @change="setDestinationAge">
                  <option v-for="dest_age in destinationAges" :value="dest_age" :key="dest_age" dir="rtl">
                    <p>{{ dest_age }}</p>
                  </option>
                </select>
                <div class="select-wrapper block">
                  <div class="input-select">{{ form.destination_age }}</div>
                </div>
              </div>
              <span class="text">Jahre</span>
            </label>
            <div class="vrnet-hint">
              <div v-if="hintInfoId == 3" class="hint-wrapper tooltip hide-mobile">
                <div class="hint-info">
                  {{ tooltip.destination_age }}
                </div>
              </div>
            </div>
          </div>

          <div class="vrnet-row-input">
            <label :class="hintInfoId == 2 ? 'orange' : 'normal'">
              Einzahlung in Euro
              <span class="vrnet-icon-wrapper" @click="onHintIconClick(2)">
                <vrnet-icons :class-name="['vrnet-icon icon-hint', { 'open' : hintInfoId == 2 }]" :type="hintInfoId == 2 ? 'info-orange' : 'info-blue'"/>
              </span>
            </label>
            <div class="vrnet-hint show-mobile">
              <div v-if="hintInfoId == 2" class="hint-wrapper tooltip">
                <div class="hint-info">
                  {{ tooltip.single_premium }}
                </div>
              </div>
            </div>
            <label class="label-right hide-all show-small">
              <div class="input-wrapper">
                <select :value="form.single_premium" class="input-select no-border" dir="rtl" @change="setPremiumValue">
                  <option v-for="item in premiumItems" :value="item.value" :key="item.value" dir="rtl">
                    <p>{{ item.text }}</p>
                  </option>
                </select>
                <div class="select-wrapper block">
                  <div class="input-select">{{ formatMoney(form.single_premium) }}</div>
                </div>
              </div>
              <span class="text">EUR</span>
            </label>
            <div class="vrnet-hint">
              <div v-if="hintInfoId == 2" class="hint-wrapper bottom-space tooltip hide-mobile">
                <div class="hint-info">
                  {{ tooltip.single_premium }}
                </div>
              </div>
            </div>
            <div class="vrnet-slider-wrapper hide-all show-large show-medium">
              <div class="vue-slider-container">
                <nSliderVRNET :value="form.single_premium" :label-values="labelValues" :valid-values="validPremiumValues" :min="20000" :max="1000000" :interval="10000" @change="setPremiumValueFromSlider"/>
              </div>
              <label class="label-right">
                <span class="value">{{ formatMoney(form.single_premium) }}</span>
                <span class="text">EUR</span>
              </label>
            </div>
          </div>

          <div class="vrnet-row-input">
            <label :class="hintInfoId == 4 ? 'orange' : 'normal'">
              Angenommener Kapitalmarktverlauf
              <span class="vrnet-icon-wrapper" @click="onHintIconClick(4)">
                <vrnet-icons :class-name="['vrnet-icon icon-hint', { 'open' : hintInfoId == 4 }]" :type="hintInfoId == 4 ? 'info-orange' : 'info-blue'"/>
              </span>
            </label>
            <div class="vrnet-hint">
              <div v-if="hintInfoId == 4" class="hint-wrapper tooltip block">
                <div class="hint-info">
                  {{ tooltip.trend }}
                </div>
              </div>
            </div>
            <div v-for="_trend in trendItems" :key="_trend" class="vkb-nak-radio-wrapper" @click="onSelectTrend(_trend)">
              <span :class="['vkb-nak-radio-mask', form.trend == _trend ? 'checked' : '']"/>
              <span class="vkb-nak-radio-label">{{ _trend }}</span>
            </div>
          </div>

          <div class="vrnet-row-input button-wrapper">
            <div class="hide-all show-large show-medium">
              <a href="#" class="vrnet-button btn-secondary" @click="onShowResult">
                <span v-if="!showResult">Jetzt berechnen</span>
                <span v-else>Neu berechnen</span>
              </a>
            </div>
            <div class="hide-all show-small btn-block">
              <a href="#" class="vrnet-button btn-secondary" @click="onShowResult">
                <span v-if="!showResult">Jetzt berechnen</span>
                <span v-else>Neu berechnen</span>
              </a>
            </div>
          </div>

          <div :class="[!showResult ? 'slide-up-reverse' : 'slide-down-reverse']">
            <div v-if="showResult" class="slide-block">
              <div class="vrnet-row-input vrnet-org-box highlight">
                <h2>
                  <label :class="['heading', { 'orange' : hintInfoId == 5 }]">
                    Kapitalleistung
                    <span class="vrnet-icon-wrapper" @click="onHintIconClick(5)">
                      <vrnet-icons :class-name="['vrnet-icon icon-hint', { 'open' : hintInfoId == 5 }]" :type="hintInfoId == 5 ? 'info-orange' : 'info-blue'"/>
                    </span>
                  </label>
                  <div class="vrnet-hint">
                    <div v-if="hintInfoId == 5" class="hint-wrapper block">
                      <div class="hint-info">
                        {{ tooltip.capital }}
                      </div>
                    </div>
                  </div>
                </h2>
                <div class="vrnet-result-wrapper">
                  <div class="result-row">
                    <div class="result-cell-description">
                      <p>Auszahlung bei R&uuml;ckkauf</p>
                    </div>
                    <div class="result-cell-amount">
                      <p class="h2">€ {{ formatMoney(result.credit) }}</p>
                    </div>
                  </div>
                  <div class="result-row">
                    <div class="result-cell-description">
                      <p>Auszahlung bei Ableben</p>
                    </div>
                    <div class="result-cell-amount">
                      <p class="h2">€ {{ formatMoney(result.fatality) }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="vrnet-row-input">
                  <div class="vrnet-button-wrapper">
                    <div class="btn-small-block columns hide-all show-large show-medium text-right">
                      <a href="#" class="vrnet-button btn-third" @click="getPDF">
                        Berechnung speichern
                      </a>
                    </div>
                    <div class="btn-small-block columns hide-all show-small text-right">
                      <a href="#info-tip" class="vrnet-button btn-third" @click="onShowResult">
                        Berechnung speichern
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logic from './logic.js';
import nSliderVRNET from '@/components/common/n-slider-vrnet.vue';
import vrnetIcons from '@/components/common/vrnet-icons.vue';
import { ogrFrameMsg } from '@/modules/ogrFrameMsg';

export default {
  name: 'generationendepot_vrnet',
  components: { nSliderVRNET, vrnetIcons },
  mixins: [logic],
  data() {
    return {
      hintInfoId: 0,
      hintErrorId: 0,
      labelValues: [20000, 500000, 1000000],
    };
  },
  computed: {
    invalidId() {
      if (this.$v.$invalid && this.$v.form.age.$invalid) {
        return 1;
      }
      return 0;
    }
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  mounted() {
    /* this.initIframeHandler(); */
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    adjustIframeHeight: function() {
      const _this = this.$refs.vrnet_iframe;
      if (!_this || typeof _this === undefined) {
        return;
      }
      ogrFrameMsg.send(_this.clientHeight + 30, false);
    },
    onErrorIconClick(id) {
      this.hintInfoId = this.hintInfoId == id ? 0 : this.hintInfoId;
      this.hintErrorId = this.hintErrorId == id ? 0 : id;
      this.onResize();
    },
    onHintIconClick(id) {
      this.hintErrorId = this.hintErrorId == id ? 0 : this.hintErrorId;
      this.hintInfoId = this.hintInfoId == id ? 0 : id;
      this.onResize();
    },
    onResize() {
      setTimeout(() => { this.adjustIframeHeight(); }, 200);
    },
    onShowResult(e) {
      this.expandResult(e);
      this.onResize();
    },
    setFocusToInput(ref) {
      if (!ref || !this.$refs[ref]) {
        return;
      }
      this.$refs[ref].focus();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/generationendepot/vrnet.vue